import React from "react";
import dayjs from "dayjs";
import { isMobileViewport } from "../../utils/responsive";
import EmptyState from "../common/empty_state";

const formatNumberWithCommaAndDecimal = (number, decimalPlaces = 3) => {
    if (isNaN(number)) return "";
    return Number(number).toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
};

class HistoryTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = { page: 1 };
    }

    handlePageChange = (nextPage, totalPages) => {
        this.setState({ page: Math.min(Math.max(nextPage, 1), totalPages) });
    };

    render() {
        const isMobile = isMobileViewport();
        const pageSize = isMobile ? 8 : 15;
        const dataSource = this.props.balanceHistory || [];
        const totalPages = Math.max(1, Math.ceil(dataSource.length / pageSize));
        const currentPage = Math.min(this.state.page, totalPages);
        const pageData = dataSource.slice((currentPage - 1) * pageSize, currentPage * pageSize);

        return (
            <div className="w-full rounded-2xl border border-surface-border bg-surface-card p-4 shadow-card">
                <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-content-secondary">잔고 히스토리</h3>
                    <div className="font-num text-xs text-content-muted">{currentPage} / {totalPages}</div>
                </div>

                <div className="mt-4 overflow-x-auto">
                    <table className="w-full min-w-full table-fixed border-collapse text-xs sm:text-sm">
                        <thead className="bg-surface-elevated text-xs font-semibold uppercase tracking-wider text-content-secondary">
                            <tr>
                                <th className="w-24 px-2 py-2 text-left sm:w-36 sm:px-3">기준 시각</th>
                                <th className="hidden sm:table-cell w-28 px-2 py-2 text-center sm:px-3">적용 환율</th>
                                <th className="hidden sm:table-cell w-32 px-2 py-2 text-center sm:px-3">Risky 잔고</th>
                                <th className="w-28 px-2 py-2 text-center sm:w-32 sm:px-3">Fiat 잔고</th>
                                <th className="w-28 px-2 py-2 text-center sm:w-32 sm:px-3">총 잔고</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageData.map((record, idx) => (
                                <tr key={record.id || record.created || idx} className="border-b border-surface-border transition-colors hover:bg-surface-hover">
                                    <td className="whitespace-nowrap px-2 py-2 text-left text-content-secondary sm:px-3 sm:py-3">
                                        {isMobile ? dayjs(record.created).format("MM-DD HH:mm") : dayjs(record.created).format("YYYY-MM-DD HH:mm")}
                                    </td>
                                    <td className="hidden sm:table-cell whitespace-nowrap px-2 py-2 text-center font-num text-content sm:px-3 sm:py-3">
                                        ₩{formatNumberWithCommaAndDecimal(record.exchange_rate, 2)}
                                    </td>
                                    <td className="hidden sm:table-cell whitespace-nowrap px-2 py-2 text-center sm:px-3 sm:py-3">
                                        <div className="font-num text-content">${formatNumberWithCommaAndDecimal(record.risky_balance, 2)}</div>
                                        <div className="font-num text-xs text-content-muted">₩{formatNumberWithCommaAndDecimal(record.risky_balance_krw, 0)}</div>
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-center font-num text-content sm:px-3 sm:py-3">
                                        ₩{formatNumberWithCommaAndDecimal(record.fiat_balance, 0)}
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-center font-num font-semibold text-content sm:px-3 sm:py-3">
                                        ₩{formatNumberWithCommaAndDecimal(record.total_balance, 0)}
                                    </td>
                                </tr>
                            ))}
                            {pageData.length === 0 && (
                                <tr>
                                    <td colSpan={5}>
                                        <EmptyState title="표시할 데이터가 없습니다" />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-4 flex items-center justify-end gap-2">
                    <button type="button" onClick={() => this.handlePageChange(currentPage - 1, totalPages)} disabled={currentPage <= 1} className="min-h-[44px] rounded-md border border-surface-border px-3 py-2.5 text-xs font-semibold text-content-secondary disabled:cursor-not-allowed disabled:text-content-muted transition-colors hover:bg-surface-hover">이전</button>
                    <button type="button" onClick={() => this.handlePageChange(currentPage + 1, totalPages)} disabled={currentPage >= totalPages} className="min-h-[44px] rounded-md border border-surface-border px-3 py-2.5 text-xs font-semibold text-content-secondary disabled:cursor-not-allowed disabled:text-content-muted transition-colors hover:bg-surface-hover">다음</button>
                </div>
            </div>
        );
    }
}

export default HistoryTable;
